import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "src/components/ui/sheet";
import { BuyerRequirementForm } from "./BuyerRequirementForm";
import {
  useCreateBuyerRequirement,
  useUpdateBuyerRequirement,
} from "../hooks/useBuyerRequirements";
import { useToast } from "src/components/ui/toast";

export function BuyerRequirementDrawer({
  open,
  onClose,
  requirement,
  onSuccess,
}) {
  const isEdit = !!requirement;
  const { toast } = useToast();

  const createHook = useCreateBuyerRequirement();
  const updateHook = useUpdateBuyerRequirement();

  const isPending = createHook.isPending || updateHook.isPending;

  async function handleSubmit(data) {
    const payload = Object.fromEntries(
      Object.entries(data).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined
      )
    );

    try {
      if (isEdit) {
        await updateHook.mutate(requirement.id, payload);
        toast({ title: "Requirement updated" });
      } else {
        await createHook.mutate(payload);
        toast({ title: "Requirement created" });
      }
      onSuccess?.();
      onClose();
    } catch (errors) {
      const msg = Array.isArray(errors)
        ? errors[0]
        : errors?.message || "Something went wrong";
      toast({ variant: "destructive", title: "Error", description: msg });
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[480px]">
        <SheetHeader>
          <SheetTitle>
            {isEdit ? "Edit Requirement" : "New Requirement"}
          </SheetTitle>
          <SheetDescription>
            {isEdit
              ? "Update the buyer requirement details below."
              : "Fill in the details to create a new buyer requirement."}
          </SheetDescription>
        </SheetHeader>

        <BuyerRequirementForm
          requirement={requirement}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isPending={isPending}
        />
      </SheetContent>
    </Sheet>
  );
}
